export default class Link {
  href: string;

  constructor(href: string) {
    this.href = href;
  }
}
